import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.accountdetail.breadcrumb.label1'),
    link: '/account',
  },
  { label: t('pages.accountdetail.breadcrumb.label2') },
];
